import { configureStore, combineReducers } from '@reduxjs/toolkit';

import appSlice from 'features/app/appSlice';
import lunaStreamsReducers from 'partials/features/reducer';

const reducer = combineReducers({
  app: appSlice,
  ...lunaStreamsReducers,
});

const store = configureStore({
  reducer,
});

export default store;
